// extracted by mini-css-extract-plugin
export var searches = "styles-module--searches--zxFJD";
export var isPostPage = "styles-module--isPostPage--8Kq7z";
export var tag = "styles-module--tag--Ga4hS";
export var active = "styles-module--active--oww1o";
export var ProPath = "styles-module--ProPath--zMnmW";
export var ITIL = "styles-module--ITIL--Tp5iG";
export var Transformation = "styles-module--Transformation--ITOof";
export var Maturity = "styles-module--Maturity--aCLsA";
export var RESILIA = "styles-module--RESILIA--hLzmf";